export default "__VITE_ASSET__DqkxKJCD__"